import { SagaIterator } from "redux-saga";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { BulkLimitConfigFileCheckerRemarkSaga, BulkLimitConfigFileMakerRemarkSaga, bulkLimitConfigFileType, BulkLimitConfigFileVersionSaga, downloadBulkLimitConfigFileSaga, fetchBulkLimitConfigFileDetailSaga, fetchBulkLimitConfigFileSaga, uploadBulkLimitConfigFileSaga } from "./types";
import { approveBulkLimitConfigFileApi, bulkLimitConfigFilePublishApi, deleteBulkLimitConfigFileApi, downloadBulkLimitConfigFileApi, fetchBulkFileSpecificLimitConfigApi, fetchBulkLimitConfigFileApi, fetchBulkLimitConfigFileDetailApi, fetchBulkLimitConfigFileVersionApi, rejectBulkLimitConfigFileApi, uploadBulkLimitConfigFileApi } from "./api";

function* uploadBulkLimitConfigFile({ payload, type }: uploadBulkLimitConfigFileSaga): SagaIterator {
    try {
        const response = yield call(uploadBulkLimitConfigFileApi, payload);
        yield put({
            type: bulkLimitConfigFileType.UPLOAD_BULK_LIMIT_CONFIG_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkLimitConfigFileType.UPLOAD_BULK_LIMIT_CONFIG_FILE_ERROR,
            payload: { error: error }
        });
    }
}
function* fetchBulkLimitConfigFile({ payload, type }: fetchBulkLimitConfigFileSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkLimitConfigFileApi, payload);
        yield put({
            type: bulkLimitConfigFileType.FETCH_BULK_LIMIT_CONFIG_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkLimitConfigFileType.FETCH_BULK_LIMIT_CONFIG_FILE_ERROR,
            payload: { error: error }
        });
    }
}
function* DownloadBulkLimitConfigFile({ payload, type }: downloadBulkLimitConfigFileSaga): SagaIterator {
    try {
        const response = yield call(downloadBulkLimitConfigFileApi, payload);
        const fileURL = payload.downloadURL.split("/")
        const responseData = {
            fileBlob: response.data,
            fileName: fileURL[fileURL.length - 1]
        }
        yield put({
            type: bulkLimitConfigFileType.BULK_LIMIT_CONFIG_FILE_DOWNLOAD_SUCCESS,
            payload: { data: responseData }
        });
    } catch (error: any) {
        yield put({
            type: bulkLimitConfigFileType.BULK_LIMIT_CONFIG_FILE_DOWNLOAD_ERROR,
            payload: { error: error }
        });
    }
}
function* fetchBulkLimitConfigFileDetail({ payload, type }: fetchBulkLimitConfigFileDetailSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkLimitConfigFileDetailApi, payload);
        yield put({
            type: bulkLimitConfigFileType.FETCH_BULK_LIMIT_CONFIG_FILE_DETAIL_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkLimitConfigFileType.FETCH_BULK_LIMIT_CONFIG_FILE_DETAIL_ERROR,
            payload: { error: error }
        });
    }
}
function* fetchBulkLimitConfigFileVersion({ payload, type }: BulkLimitConfigFileVersionSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkLimitConfigFileVersionApi, payload);
        yield put({
            type: bulkLimitConfigFileType.BULK_LIMIT_CONFIG_FILE_VERSION_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkLimitConfigFileType.BULK_LIMIT_CONFIG_FILE_VERSION_ERROR,
            payload: { error: error }
        });
    }
}
function* publishBulkLimitConfigFile({ payload, type }: BulkLimitConfigFileMakerRemarkSaga): SagaIterator {
    try {
        const response = yield call(bulkLimitConfigFilePublishApi, payload);
        yield put({
            type: bulkLimitConfigFileType.PUBLISH_BULK_LIMIT_CONFIG_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkLimitConfigFileType.PUBLISH_BULK_LIMIT_CONFIG_FILE_ERROR,
            payload: { error: error }
        });
    }
}
function* approveBulkLimitConfigFile({ payload, type }: BulkLimitConfigFileCheckerRemarkSaga): SagaIterator {
    try {
        const response = yield call(approveBulkLimitConfigFileApi, payload);
        yield put({
            type: bulkLimitConfigFileType.APPROVE_BULK_LIMIT_CONFIG_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkLimitConfigFileType.APPROVE_BULK_LIMIT_CONFIG_FILE_ERROR,
            payload: { error: error }
        });
    }
}
function* rejectBulkLimitConfigFile({ payload, type }: BulkLimitConfigFileCheckerRemarkSaga): SagaIterator {
    try {
        const response = yield call(rejectBulkLimitConfigFileApi, payload);
        yield put({
            type: bulkLimitConfigFileType.REJECT_BULK_LIMIT_CONFIG_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkLimitConfigFileType.REJECT_BULK_LIMIT_CONFIG_FILE_ERROR,
            payload: { error: error }
        });
    }
}
function* fetchBulkFileSpecificLimitConfig({ payload, type }: BulkLimitConfigFileVersionSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkFileSpecificLimitConfigApi, payload);
        yield put({
            type: bulkLimitConfigFileType.FETCH_BULK_FILE_SPECIFIC_LIMIT_CONFIG_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkLimitConfigFileType.FETCH_BULK_FILE_SPECIFIC_LIMIT_CONFIG_ERROR,
            payload: { error: error }
        });
    }
}

function* deleteBulkLimitConfigFile({ payload, type }: fetchBulkLimitConfigFileDetailSaga): SagaIterator {
    try {
        const response = yield call(deleteBulkLimitConfigFileApi, payload);
        yield put({
            type: bulkLimitConfigFileType.DELETE_BULK_LIMIT_CONFIG_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkLimitConfigFileType.DELETE_BULK_LIMIT_CONFIG_FILE_ERROR,
            payload: { error: error }
        });
    }
}


export function* watchUploadBulkLimitConfigFile() {
    yield takeEvery(bulkLimitConfigFileType.UPLOAD_BULK_LIMIT_CONFIG_FILE, uploadBulkLimitConfigFile);
}
export function* watchFetchBulkLimitConfigFile() {
    yield takeEvery(bulkLimitConfigFileType.FETCH_BULK_LIMIT_CONFIG_FILE, fetchBulkLimitConfigFile);
}
export function* watchDownloadBulkLimitConfigFile() {
    yield takeEvery(bulkLimitConfigFileType.BULK_LIMIT_CONFIG_FILE_DOWNLOAD, DownloadBulkLimitConfigFile);
}
export function* watchFetchBulkLimitConfigFileDetail() {
    yield takeEvery(bulkLimitConfigFileType.FETCH_BULK_LIMIT_CONFIG_FILE_DETAIL, fetchBulkLimitConfigFileDetail);
}
export function* watchBulkLimitConfigFileVersion() {
    yield takeEvery(bulkLimitConfigFileType.BULK_LIMIT_CONFIG_FILE_VERSION, fetchBulkLimitConfigFileVersion);
}
export function* watchPublishBulkLimitConfigFile() {
    yield takeEvery(bulkLimitConfigFileType.PUBLISH_BULK_LIMIT_CONFIG_FILE, publishBulkLimitConfigFile);
}
export function* watchApproveBulkLimitConfigFile() {
    yield takeEvery(bulkLimitConfigFileType.APPROVE_BULK_LIMIT_CONFIG_FILE, approveBulkLimitConfigFile);
}
export function* watchRejectBulkLimitConfigFile() {
    yield takeEvery(bulkLimitConfigFileType.REJECT_BULK_LIMIT_CONFIG_FILE, rejectBulkLimitConfigFile);
}
export function* watchFetchBulkFileSpecificLimitConfig() {
    yield takeEvery(bulkLimitConfigFileType.FETCH_BULK_FILE_SPECIFIC_LIMIT_CONFIG, fetchBulkFileSpecificLimitConfig);
}
export function* watchDeleteBulkLimitConfigFile() {
    yield takeEvery(bulkLimitConfigFileType.DELETE_BULK_LIMIT_CONFIG_FILE, deleteBulkLimitConfigFile);
}

function* BulkLimitConfigFileSaga() {
    yield all([
        fork(watchUploadBulkLimitConfigFile),
        fork(watchFetchBulkLimitConfigFile),
        fork(watchDownloadBulkLimitConfigFile),
        fork(watchFetchBulkLimitConfigFileDetail),
        fork(watchBulkLimitConfigFileVersion),
        fork(watchPublishBulkLimitConfigFile),
        fork(watchApproveBulkLimitConfigFile),
        fork(watchRejectBulkLimitConfigFile),
        fork(watchFetchBulkFileSpecificLimitConfig),
        fork(watchDeleteBulkLimitConfigFile)
    ]);
}
export default BulkLimitConfigFileSaga;